import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyNote, HttpResponse, UpdateCompanyNoteRequest } from "@/types";

export function useUpdateCompanyNote() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      companyNoteId,
      updateCompanyNoteRequest,
    }: {
      companyNoteId: number;
      updateCompanyNoteRequest: UpdateCompanyNoteRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-notes/${companyNoteId.toString()}`;
      const res = await guacHttpClient.patch<
        CompanyNote,
        HttpResponse<CompanyNote>,
        UpdateCompanyNoteRequest
      >(path, updateCompanyNoteRequest);

      return res.data;
    },
  });

  return mutation;
}
